import React from "react";

import {
  ABILITY_KEYS,
  calculateHP,
  getAttributeTotal,
  getFullName,
  getPreviewBadges,
  getPreviewLetter,
  getSubtitle,
  modStr,
} from "../characterCreatorUtils.js";

export default function PreviewPanel({ state, isMobile = false }) {
  const previewBadges = getPreviewBadges(state);
  const hpValue = state.charClass && state.startingPointData ? calculateHP(state) : "—";
  const profValue = state.startingPointData ? `+${state.startingPointData.proficiencyBonus}` : "—";
  const fullName = getFullName(state);
  const avatarImage = state.profileImageCropped || state.profileImageOriginal || "";

  return (
    <aside className="preview-panel" style={isMobile ? { display: "flex" } : undefined}>
      <div className="preview-avatar">
        {avatarImage ? (
          <img
            className="preview-avatar-img"
            src={avatarImage}
            alt={`Retrato de ${fullName}`}
            loading="lazy"
          />
        ) : (
          getPreviewLetter(state)
        )}
      </div>
      <div className="preview-name">{fullName}</div>
      <div className="preview-subtitle">{getSubtitle(state)}</div>
      <div className="preview-badges">
        {previewBadges.map((badge) => (
          <span
            key={badge.key}
            className={`preview-badge${badge.className ? ` ${badge.className}` : ""}`}
          >
            {badge.label}
          </span>
        ))}
      </div>
      <div className="preview-stats">
        {ABILITY_KEYS.map((key) => {
          const total = getAttributeTotal(state, key);
          return (
            <div key={key} className="stat-box">
              <div className="stat-label">{key.toUpperCase()}</div>
              <div className="stat-value">{total}</div>
              <div className="stat-mod">({modStr(total)})</div>
            </div>
          );
        })}
      </div>
      <div className="preview-hp">
        <span>HP</span> <span className="hp-val">{hpValue}</span>
        <span>| Prof</span>
        <span className="hp-val" style={{ color: "var(--gold-blue)" }}>
          {profValue}
        </span>
      </div>
    </aside>
  );
}
